import React from "react";
import { useSelector } from "react-redux";
import useInterval from "use-interval";
import notification from "../../styles/notification.wav";
import {
  popupMessagesHandler,
  set_Refresh,
} from "../General/generalActionCreators";
import Store from "../Store";
import {
  findActiveOrders,
  findReadyToSendOrders,
  findRejectedOrders,
} from "./OrderActionCreators";
import { getActive_Ready_Orders } from "./ordersActions";

const useOrders = () => {
  const [ordersLength, setOrdersLength] = React.useState(0);
  const audio = new Audio(notification);

  const { refresh, letRefresh } = useSelector((state) => state.generalReducer);
  const { activeOrders } = useSelector((state) => state.OrderReducer);
  const timer =
    localStorage.recall_interval_timer !== undefined
      ? Number(localStorage.recall_interval_timer)
      : 100;

  const updateNewOrders = ({ id }) => {
    Store.dispatch(
      findActiveOrders(activeOrders.filter((order) => order.id !== id))
    );
  };
  // // --------------------------------------------------------------------------- seting lengths for sidbar and notification sound
  React.useEffect(() => {
    if (!letRefresh) return;
    getActive_Ready_Orders().then((res) => {
      if (!res) return;

      Store.dispatch(findActiveOrders([...res.activeOrders]));
      Store.dispatch(findReadyToSendOrders(res.ReadyOrders));
      Store.dispatch(findRejectedOrders(res.RejectedOrders));
    });

    // eslint-disable-next-line
  }, [refresh]);

  // ---------------------------------------------------------------------------notification audio
  React.useEffect(() => {
    if (activeOrders.length > ordersLength) {
      const count = activeOrders.length - ordersLength;
      setOrdersLength(activeOrders.length);

      audio
        .play()
        .then((res) => {})
        .catch((err) => {});
      Store.dispatch(
        popupMessagesHandler({
          mode: true,
          message: `${count} سفارش جدید`,
          color: "info",
        })
      );
    } else if (activeOrders.length < ordersLength) {
      setOrdersLength(activeOrders.length);
    }
    // eslint-disable-next-line
  }, [activeOrders]);
  useInterval(() => {
    Store.dispatch(set_Refresh(refresh + 1));
  }, 1000 * timer);
  return { updateNewOrders };
};

export default useOrders;
